import SupremeGolfApiClient from './SupremeGolfApiClient';

const APPLE_WALLET_PASS = 'v6/mobile_wallet/ios';
const GOOGLE_WALLET_PASS = 'v6/mobile_wallet/android';

class WalletApi {
  static async getAppleWalletPass(reservationId, accessToken) {
    const payload = { id: reservationId };
    if (accessToken) payload.accessToken = accessToken;
    const response = await SupremeGolfApiClient.post(`${APPLE_WALLET_PASS}/${reservationId}`, payload, false, { responseType: 'blob' });
    const { data } = response;
    return data;
  }

  static async getGoogleWallet(reservationId, accessToken) {
    const payload = { id: reservationId };
    if (accessToken) payload.accessToken = accessToken;
    const response = await SupremeGolfApiClient.post(`${GOOGLE_WALLET_PASS}/${reservationId}`, payload);
    const { data } = response;
    return data;
  }
}

export default WalletApi;
